import Service from '@/services/modules/download_bills.service';

const execute = async({ commit }, _object) => {
    const response = Service.download(_object);
    return response;
};

export default {
    execute
};